class ValidateNavigation {
  constructor(order) {
    this.order = order
  }

  validateCurrentStep(currentComponent) {
    if (currentComponent === "ScopeSelection") return this.scopeSelectionComplete();
    if (currentComponent === "SelfInclusionSelection") return this.selfInclusionSelectionComplete();
    if (currentComponent === "PlacesRequiredSelection") return this.placesRequiredComplete();
    if (currentComponent === "EmailSelection") return this.emailSelectionComplete();
    if (currentComponent === "ContactDetails") return this.contactDetailsComplete();
    if (currentComponent === "ParticipantsList" || currentComponent === 'Confirmation' || currentComponent === 'Payment') {
      return this.participantsStepComplete();
    }
  }

  scopeSelectionComplete() {
    let validBookingTypes = ['individual', 'group']
    return validBookingTypes.includes(this.order.bookingType)
  }

  selfInclusionSelectionComplete() {
    if (!this.scopeSelectionComplete()) return false;
    let bookingForSelf = this.order.bookingForSelf
    return bookingForSelf || bookingForSelf === false
  }

  placesRequiredComplete() {
    if (!this.selfInclusionSelectionComplete()) return false;
    let placesRequired = parseInt(this.order.placesRequired);
    if (this.order.bookingType === 'individual') return placesRequired === 1
    return placesRequired > 0
  }

  emailSelectionComplete() {
    if (!this.placesRequiredComplete()) return false;
    let email = this.order.contact_email
    return email
  }

  contactDetailsComplete() {
    if (!this.emailSelectionComplete()) return false;
    let contact = this.order.contact
    if (!contact) return false;

    if (!contact.first_name) return false
    if (!contact.mobile_phone) return false
    if (!contact.email) return false
    return true
  }

  participantsStepComplete() {
    if (!this.contactDetailsComplete()) return false;
    if (this.order.participants.length < 1 ) return false;
    return this.order.participants.length <= this.order.placesRequired
  }
}

export default ValidateNavigation